import { OrgAdminConstants } from '../../../_constants';

const initialState = { getOrgTeamsLoading: true, data: '', error: false };

export function getOrgTeams(state = initialState, action) {
    
    switch (action.type) {
        case OrgAdminConstants.REQUEST_ORG_TEAM:
            return {
                getOrgTeamsLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_ORG_TEAM:
            return {
                getOrgTeamsLoading: false,
                data: action.getOrgTeam,
                error: false
            };
        case OrgAdminConstants.ORG_TEAM_ERROR:
            return {
                getOrgTeamsLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/OrgTeam/getOrgTeam.reducer.js